import React from 'react';
import {
  bannerCarbonOffset,
  imageCarbonOffset,
  CarbonOffsetLogic,
  useStyles,
} from './carbonOffset.module';
import BannerInterface from '../shared/bannerInterface/bannerInterface';
import Footer from '../footer/Footer';
import InfoQuestions from '../shared/infoQuestions/infoQuestion';
import { Container } from '@material-ui/core';
import OurProjects from '../ourProjects/ourProjects';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
const CarbonOffset = () => {
  const { translator } = CarbonOffsetLogic();
  const classes = useStyles();
  const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'));

  return (
    <>
      <BannerInterface
        backgroundImg={bannerCarbonOffset}
        bannerTitle={[translator('carbonOffset.title'), translator('')]}
        descriptionTexts={
          isMobile
            ? [translator('carbonOffset.subtitle')]
            : [
                translator('carbonOffset.subtitleOne'),
                translator('carbonOffset.subtitleTwo'),
                translator('carbonOffset.subtitleThree'),
              ]
        }
      />
      <Container className={classes.contentCarbonOffset}>
        <InfoQuestions
          textInfo2={translator('carbonOffset.textInfo')}
          srcCarbonOffset={imageCarbonOffset}
          text={translator('carbonOffset.text')}
          to=""
          typeButton="backgroundwhite"
          children={translator('carbonOffset.children')}
          showOneImg={true}
        />
        <OurProjects />
      </Container>
      <Footer />
    </>
  );
};

export default CarbonOffset;
